import { default as zRoute } from '@ziggy/js';
import { Ziggy } from 'ziggy';

export default function route(routeName, routeParams) {
    return zRoute.apply(null, [routeName, routeParams, true, Ziggy]);
}
